import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      toast.success("Sıfırlama linki e-postanıza gönderildi (dev: log kontrol edin)");
      nav("/login");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0E] p-4">
      <div className="glass-card rounded-2xl p-8 max-w-md w-full" style={{ background: "rgba(20,20,26,0.8)" }}>
        <h1 className="font-display text-2xl font-bold text-white mb-2 tracking-tight">Şifremi Unuttum</h1>
        <p className="text-white/60 text-sm mb-6">E-postanızı girin, sıfırlama linki gönderelim.</p>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="text-white/80">E-posta</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="bg-white/5 border-white/10 text-white" data-testid="fp-email" />
          </div>
          <Button disabled={busy} className="w-full bg-blue-600 hover:bg-blue-500" data-testid="fp-submit">
            {busy ? "Gönderiliyor..." : "Gönder"}
          </Button>
          <Link to="/login" className="block text-center text-sm text-blue-400 hover:text-blue-300 mt-3">Girişe dön</Link>
        </form>
      </div>
    </div>
  );
}
